/**
 * Pure decision logic shared by the media blocks' onError handlers.
 *
 * A media block should swap in the clean placeholder (MediaFallback) ONLY when
 * a load actually failed for a *real* source. An empty / whitespace-only src is
 * "no media selected yet" — that keeps its existing empty-state icon and must
 * NOT be treated as an error. Extracted so the gating rule is unit-testable
 * without rendering React (no new test dependencies required).
 *
 * @param {unknown} src - the media source the block tried to load
 * @returns {boolean} true if a fallback placeholder should be shown
 */
export const shouldShowMediaFallback = (src) =>
  Boolean(src) && String(src).trim() !== "";

export default shouldShowMediaFallback;
